<template>
    <div>
        <v-row>
            <v-col sm="4">
                <div class="v-center pb-2">
                    <p>
                        {{ $t('modules.benefits.create.unique_discount.unique_label') }}
                    </p>
                </div>
            </v-col>
            <v-col sm="3">
                <v-text-field
                    :label="`${$t('modules.benefits.create.referred_friend.amount')} *`"
                    :error-messages="(friend.referredAmount.$error && friend.referredAmount.$dirty) ? $t('actions.error') : ''"
                    type="text"
                    outlined
                    @keypress="$validateDecimalInputNumber($event, friend.referredAmount.$model)"
                    v-model.trim="friend.referredAmount.$model"
                    @blur="friend.referredAmount.$touch()"
                    class="no-message"
                >
                  <template v-slot:prepend>
                    <span>{{ $countryConstants.currency }}</span>
                  </template>
                </v-text-field>
            </v-col>
        </v-row>
    </div>
</template>

<style lang="sass" scoped>
    .v-center
        height: 100%
</style>

<script>
    export default {
        name: 'UniqueDiscount',
        props: {
            friend: Object,
        },
    }
</script>